import React, { useEffect } from 'react';
import { setPageSeo, setJsonLd } from '../utils/seo';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPage() {
  useEffect(() => {
    setPageSeo({
      title: 'Privacy Policy | Binding Thread \u2014 Your Stories Stay Safe',
      description: 'Learn how Binding Thread collects, uses, and protects your data. We never sell your stories or voice recordings. Your family\u2019s memories are encrypted and kept private.',
      canonical: 'https://www.bindingthread.com.au/privacy'
    });
    setJsonLd('ld-privacy', {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Privacy Policy",
      "description": "Privacy policy for Binding Thread — how we collect, use, and protect your data and voice recordings.",
      "url": "https://www.bindingthread.com.au/privacy",
      "isPartOf": {
        "@type": "WebSite",
        "name": "Binding Thread",
        "url": "https://www.bindingthread.com.au"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Binding Thread",
        "url": "https://www.bindingthread.com.au"
      }
    });
  }, []);

  return (
    <div className="privacy-page" data-testid="privacy-page">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: March 12, 2026</p>
        
        <p className="intro">
          At Binding Thread, we understand that your family stories are your most private and precious assets. 
          This policy outlines how we collect, use, and protect your data.
        </p>

        <section className="policy-section">
          <h2>A. Information We Collect</h2>
          
          <h3>Subscribers (The Buyer):</h3>
          <p>Name, email, billing address, and payment details (processed securely via Stripe).</p>
          
          <h3>Loved Ones (The Storyteller):</h3>
          <p>Name, phone number, and physical mailing address.</p>
          
          <h3>The Content:</h3>
          <p>Audio recordings of your voice and the resulting transcribed text.</p>
        </section>

        <section className="policy-section">
          <h2>B. How We Use Your Data</h2>
          
          <h3>Production:</h3>
          <p>We use the audio recordings to create the physical &quot;Living Letters.&quot;</p>
          
          <h3>Digital Archive:</h3>
          <p>We provide a copy of the audio and a PDF of the letter to the Subscriber as part of the service.</p>
          
          <h3>Communication:</h3>
          <p>We use phone numbers to send automated &quot;Welcome&quot; and &quot;Nudge&quot; SMS messages.</p>
        </section>

        <section className="policy-section">
          <h2>C. Data Security &amp; Storage</h2>
          
          <h3>Encryption:</h3>
          <p>All audio files are stored in encrypted cloud environments.</p>
          
          <h3>No Third-Party Sales:</h3>
          <p>We never sell your data, stories, or voice recordings to third parties or AI training sets.</p>
          
          <h3>Human Access:</h3>
          <p>Only authorized staff (the Founder and designated Scribes) have access to audio files for the purpose of transcription and quality control.</p>
        </section>

        <section className="policy-section">
          <h2>D. Your Rights</h2>
          <p>
            You may request the deletion of your audio files or personal data at any time by contacting us at{' '}
            <a href="mailto:admin@bindingthread.com.au">admin@bindingthread.com.au</a>.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
